<template>
  <div class="container">
    <div class="top_container">
      <span>巡检历史</span>
    </div>
    <a-tabs v-if="planList.length > 0" v-model="planId" @change="tabChange">
      <a-tab-pane v-for="item in planList" :key="item.id" :tab="item.name">
      </a-tab-pane>
    </a-tabs>
    <div class="wrapper" ref="wrapper">
      <div class="content">
        <div v-show="planList.length > 0" class="pulldown-wrapper loading_text">
          <div v-show="beforePullDown">
            <span>下拉刷新数据</span>
          </div>
          <div v-show="!beforePullDown">
            <div v-show="isPullingDown">
              <span>加载中...</span>
            </div>
            <div v-show="!isPullingDown">
              <span>刷新成功</span>
            </div>
          </div>
        </div>
        <template v-if="taskList.length > 0">
          <div v-for="task in taskList" :key="task.id" class="history_item">
            <!-- <div class="top">
              <span class="code">#{{ task.code }}</span>
              <span class="status">{{ task.status_name }}</span>
            </div> -->
            <div class="middle">
              <div class="middle_item">
                <span class="title">执行人</span>
                <span class="value">{{ task.user ? task.user.real_name : '' }}</span>
              </div>
              <div class="middle_item">
                <span class="title">执行时间</span>
                <span class="value">{{ task.created_at }}</span>
              </div>
              <extend-field-list :field-list="task.fieldValueList" className="middle_item"></extend-field-list>
            </div>
          </div>
        </template>
        <div class="loading" v-if="loading"><a-icon type="loading" /></div>
        <div class="empty_container" v-if="taskList.length === 0 && !loading">
          <img src="@/assets/image/empty.png" alt="">
          <div>暂无巡检历史</div>
        </div>
        <div v-if="!noMore" style="padding: 10px" class="loading_text">
          <div v-if="!isPullUpLoad">
            <span>上拉加载更多</span>
          </div>
          <div v-else>
            <span>加载中...</span>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom_container">
      <div @click="goDevice">
        <a-icon type="appstore" />
        <span>设备档案</span>
      </div>
      <div class="current">
        <a-icon type="interaction" />
        <span>巡检历史</span>
      </div>
      <div @click="deviceOrderHistory">
        <a-icon type="tool" />
        <span>维修历史</span>
      </div>
    </div>
  </div>
</template>
<script>
import ExtendFieldList from '@/components/ExtendField/list'
import request from '@/utils/request'
import BScroll from '@better-scroll/core'
import PullDown from '@better-scroll/pull-down'
import Pullup from '@better-scroll/pull-up'
BScroll.use(PullDown)
BScroll.use(Pullup)
export default {
  components: { ExtendFieldList },
  data () {
    return {
      bscroll: null,
      beforePullDown: true,
      isPullingDown: false,
      isPullUpLoad: false,
      page: 1,
      limit: 30,
      taskList: [],
      planList: [],
      planId: undefined,
      noMore: true,
      loading: true,
      qrId: 0,
      deviceId: 0
    }
  },
  created: async function () {
    this.deviceId = this.$route.query.device_id
    this.qrId = this.$route.query.qr_id
    await request({
      url: 'device/page_plan_list',
      data: { device_id: this.deviceId }
    }).then(r => {
      this.planList = r.data.data
      if (this.planList[0]) {
        this.planId = this.planList[0].id
        this.loadData()
      } else {
        this.loading = false
        this.bscroll.closePullUp()
        this.noMore = true
        this.bscroll.closePullDown()
      }
    })
  },
  mounted () {
    this.initBscroll()
  },
  methods: {
    tabChange () {
      this.page = 1
      this.taskList = []
      this.loading = true
      this.loadData('refresh')
    },
    deviceOrderHistory () {
      this.$router.replace({ path: '/doh', query: { 
        device_id: this.deviceId,
        qr_id: this.qrId
      }})
    },
    goDevice () {
      this.$router.replace({ path: '/d', query: {
        qr_id: this.qrId
      }})
    },
    async loadData (type = '') {
      await request({
        url: 'device/page_task_list',
        data: { plan_id: this.planId, pageNo: this.page, pageSize: this.limit }
      }).then(r => {
        this.loading = false
        if (r.data.data.data.length > 0) {
          if (type === 'refresh') {
            this.taskList = r.data.data.data
          } else {
            this.taskList = this.taskList.concat(r.data.data.data);
          }
          this.page++
          this.noMore = false
          this.$nextTick(() => {
            this.bscroll.openPullUp()
            this.bscroll.refresh()
          })
        } else {
          this.bscroll.closePullUp()
          this.noMore = true
        }
      })
    },
    initBscroll() {
      this.bscroll = new BScroll(this.$refs.wrapper, {
        scrollY: true,
        bounceTime: 800,
        useTransition: false,
        pullDownRefresh: {
          threshold: 70,
          stop: 56
        },
        listenScroll: true,
        click: true,
        pullUpLoad: true
      })
      this.bscroll.on('pullingDown', this.pullingDownHandler)
      this.bscroll.on('pullingUp', this.pullingUpHandler)
    },
    async pullingDownHandler() {
      this.beforePullDown = false
      this.isPullingDown = true

      // 请求数据
      this.page = 1
      await this.loadData('refresh')

      this.isPullingDown = false
      this.finishPullDown()
    },
    finishPullDown() {
      this.bscroll.finishPullDown()
      setTimeout(() => {
        this.beforePullDown = true
        this.bscroll.refresh()
      }, 800 + 100)
    },
    async pullingUpHandler() {
      this.isPullUpLoad = true
      await this.loadData()
      if (!this.noMore) {
        this.bscroll.finishPullUp()
      }
      this.bscroll.refresh()
      this.isPullUpLoad = false
    }
  }
}
</script>
<style lang="less" scoped>
.container{
  padding-top: 50px;
  /deep/ .ant-tabs{
    margin-bottom: 0;
    z-index: 9999;
    background-color: #fff;
  }
  /deep/ .ant-tabs-bar{
    margin-bottom: 0;
  }
  .history_item{
    border-radius: 10px;
    background-color: #fff;
    margin-bottom: 10px;
    .top{
      padding: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .code{
        font-size: 20px;
        color: #009bfc;
      }
      .status{
        font-size: 16px;
        color: red;
      }
    }
    .middle{
      font-size: 16px;
      padding: 10px;
      border-top: 1px solid #f1f1f1;
      border-bottom: 1px solid #f1f1f1;
      .middle_item {
        display: flex;
        padding: 5px 0;
        .title{
          color: #999; 
          width: 80px;
        }
        .value{
          flex: 1;
          color: #222;
        }
      }
    }
    .bottom{
      font-size: 16px;
      color: #999;
      padding: 10px;
    }
  }
  .wrapper{
    position: fixed;
    left: 10px;
    bottom: 70px;
    height: calc(100% - 172px);
    width: calc(100% - 20px);
    .pulldown-wrapper{
      position: absolute;
      width: 100%;
      padding: 22px;
      box-sizing: border-box;
      transform: translateY(-100%) translateZ(0);
    }
    .loading_text{
      text-align: center;
      color: #999;
    }
  }
}
.empty_container{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img{
    margin-top: 30%;
    width: 80%;
  }
}
.loading{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(240,242,245, 1);
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
}
</style>
